export const zodHu = {
  errors: {
    invalid_type: "{{expected}} típus várva, {{received}} érkezett",
    invalid_type_received_undefined: "Kötelező mező",
    invalid_type_received_null: "Kötelező mező",
    invalid_literal: "Érvénytelen literál érték, {{expected}} várva",
    unrecognized_keys: "Ismeretlen kulcs(ok) az objektumban: {{- keys}}",
    invalid_union: "Érvénytelen bemenet",
    invalid_union_discriminator:
      "Érvénytelen megkülönböztető érték. {{- options}} várva",
    invalid_enum_value:
      "Érvénytelen enum érték. {{- options}} várva, '{{received}}' érkezett",
    invalid_arguments: "Érvénytelen függvény argumentumok",
    invalid_return_type: "Érvénytelen függvény visszatérési típus",
    invalid_date: "Érvénytelen dátum",
    custom: "Érvénytelen bemenet",
    invalid_intersection_types:
      "Az intersection eredményeket nem lehetett egyesíteni",
    not_multiple_of: "A számnak {{multipleOf}} többszörösének kell lennie",
    not_finite: "A számnak végesnek kell lennie",
    invalid_string: {
      email: "Érvénytelen {{validation}}",
      url: "Érvénytelen {{validation}}",
      uuid: "Érvénytelen {{validation}}",
      cuid: "Érvénytelen {{validation}}",
      regex: "Érvénytelen",
      datetime: "Érvénytelen {{validation}}",
      startsWith:
        'Érvénytelen bemenet: "{{startsWith}}" karakterekkel kell kezdődnie',
      endsWith:
        'Érvénytelen bemenet: "{{endsWith}}" karakterekkel kell végződnie',
    },
    too_small: {
      array: {
        exact: "A tömbnek pontosan {{minimum}} elemet kell tartalmaznia",
        inclusive: "A tömbnek legalább {{minimum}} elemet kell tartalmaznia",
        not_inclusive: "A tömbnek {{minimum}} elemnél többet kell tartalmaznia",
      },
      string: {
        exact: "A szövegnek pontosan {{minimum}} karaktert kell tartalmaznia",
        inclusive:
          "A szövegnek legalább {{minimum}} karaktert kell tartalmaznia",
        not_inclusive:
          "A szövegnek {{minimum}} karakternél többet kell tartalmaznia",
      },
      number: {
        exact: "A számnak pontosan {{minimum}} értékűnek kell lennie",
        inclusive:
          "A számnak {{minimum}} értékkel egyenlőnek vagy nagyobbnak kell lennie",
        not_inclusive: "A számnak {{minimum}} értéknél nagyobbnak kell lennie",
      },
      set: {
        exact: "Érvénytelen bemenet",
        inclusive: "Érvénytelen bemenet",
        not_inclusive: "Érvénytelen bemenet",
      },
      date: {
        exact:
          "A dátumnak pontosan {{- minimum, datetime}} értékűnek kell lennie",
        inclusive:
          "A dátumnak {{- minimum, datetime}} értékkel egyenlőnek vagy későbbinek kell lennie",
        not_inclusive:
          "A dátumnak {{- minimum, datetime}} értéknél későbbinek kell lennie",
      },
    },
    too_big: {
      array: {
        exact: "A tömbnek pontosan {{maximum}} elemet kell tartalmaznia",
        inclusive: "A tömb legfeljebb {{maximum}} elemet tartalmazhat",
        not_inclusive:
          "A tömbnek {{maximum}} elemnél kevesebbét kell tartalmaznia",
      },
      string: {
        exact: "A szövegnek pontosan {{maximum}} karaktert kell tartalmaznia",
        inclusive: "A szöveg legfeljebb {{maximum}} karaktert tartalmazhat",
        not_inclusive:
          "A szövegnek {{maximum}} karakternél kevesebbét kell tartalmaznia",
      },
      number: {
        exact: "A számnak pontosan {{maximum}} értékűnek kell lennie",
        inclusive:
          "A számnak {{maximum}} értékkel egyenlőnek vagy kisebbnek kell lennie",
        not_inclusive: "A számnak {{maximum}} értéknél kisebbnek kell lennie",
      },
      set: {
        exact: "Érvénytelen bemenet",
        inclusive: "Érvénytelen bemenet",
        not_inclusive: "Érvénytelen bemenet",
      },
      date: {
        exact:
          "A dátumnak pontosan {{- maximum, datetime}} értékűnek kell lennie",
        inclusive:
          "A dátumnak {{- maximum, datetime}} értékkel egyenlőnek vagy korábbinak kell lennie",
        not_inclusive:
          "A dátumnak {{- maximum, datetime}} értéknél korábbinek kell lennie",
      },
    },
  },
  validations: {
    email: "e-mail cím",
    url: "URL",
    uuid: "UUID",
    cuid: "CUID",
    regex: "reguláris kifejezés",
    datetime: "dátum és idő",
  },
  types: {
    function: "függvény",
    number: "szám",
    string: "szöveg",
    nan: "nem szám",
    integer: "egész szám",
    float: "lebegőpontos szám",
    boolean: "logikai érték",
    date: "dátum",
    bigint: "nagy egész szám",
    undefined: "nem definiált",
    symbol: "szimbólum",
    null: "null",
    array: "tömb",
    object: "objektum",
    unknown: "ismeretlen",
    promise: "ígéret",
    void: "void",
    never: "soha",
    map: "térkép",
    set: "halmaz",
  },
};
